import { Box, Typography, styled } from "@mui/material";
import { StyledLink } from "react-common-ui-library/FPACT/Navigation";

export const StyledInlineLink = styled(StyledLink)(() => ({
  display: "inline-block",
}));

export const AccountStyledButtonWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  "&  .MuiBox-root": {
    flexBasis: "504px",
  },
}));

export const StyledFormInputsBox = styled(Box)(({ theme }) => ({
  width: "504px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const StyledActionButtonsBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(10),
  [theme.breakpoints.down("sm")]: {
    marginTop: theme.spacing(8),
  },
}));

export const StyledSmallerFieldWrapperBox = styled(Box)(({ theme }) => ({
  maxWidth: "241px",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
  },
}));

export const StyledTypographyHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const StyledAlertContentBox = styled(Box)(({ theme }) => ({
  "& .MuiLink-root": {
    display: "inline",
    margin: theme.spacing(0, 0.5),
  },
}));
